var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"input-message-wrapper",style:({ color: _setup.messageColor })},[_vm._t("icon",function(){return [_c(_setup.InfoWarning,{staticClass:"input-message-icon"})]}),_c('div',{staticClass:"input-message"},[_vm._v(_vm._s(_vm.message))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }